import * as React from 'react';
import { FavRow } from '../../components/Favorites/FavListUI';
import { FaveProps } from '../../data/faves';
import coinPrices, { CoinProps } from '../../data/coinPrices';
import {
  Item,
  Logo,
  Symbol,
  Volume24,
  BtcPrice,
  UsdPrice,
  Diff,
} from '../../components/Favorites/FavItem';
import BigNumber from 'bignumber.js';
import * as numeral from 'numeral';

const getDollarFmt = (num: number) => {
  if (num < 0.00000001) return numeral(num).format('$0,0.000000000');
  if (num < 0.0000001) return numeral(num).format('$0,0.00000000');
  if (num < 0.000001) return numeral(num).format('$0,0.0000000');
  if (num < 0.00001) return numeral(num).format('$0,0.000000');
  if (num < 0.0001) return numeral(num).format('$0,0.00000');
  if (num < 0.001) return numeral(num).format('$0,0.0000');
  if (num < 0.01) return numeral(num).format('$0,0.000');
  return numeral(num).format('$0,0.00');
};

const getDiff = (num: number) => {
  if (num > 0) return 'pos';
  if (num < 0) return 'neg';
  return 'zero';
};

const getPercentFmt = (num: number) => {
  if (num > 0) return `+${num}%`;
  return `${num}%`;
};

type FavItemProps = {
  fave: FaveProps;
  onSelectFave: (id: number) => (event: any) => void;
};

const FavItem: React.SFC<FavItemProps> = ({ fave, onSelectFave }) => {
  const coin: CoinProps = coinPrices[fave];
  const btcPrice = coin.quotes.btc.price;
  const usdPriceFmt = getDollarFmt(coin.quotes.usd.price || 0);
  const volume24Fmt = coin.quotes.usd.volume24h || 0;
  const usdVolume24Fmt = numeral(volume24Fmt).format('$0,0');
  const usd24Num = coin.quotes.usd.percentChange24h || 0;
  const usd24Fmt = getPercentFmt(usd24Num);
  const diff = getDiff(usd24Num);
  const btcPriceFmt = new BigNumber(btcPrice || 0).toFixed(8);
  const logoUrl = `https://s3.amazonaws.com/assets.coinmend.com/images/coins/64x64/${coin.id}.png`;
  return (
    <FavRow onClick={onSelectFave(coin.id)}>
      <Item>
        <Logo>
          <img src={logoUrl} alt={name} />
        </Logo>
        <Symbol>{coin.symbol}</Symbol>
        <Volume24>{usdVolume24Fmt}</Volume24>
        <BtcPrice>{btcPriceFmt}</BtcPrice>
        <UsdPrice>{usdPriceFmt}</UsdPrice>
        <Diff diff={diff}>{usd24Fmt}</Diff>
      </Item>
    </FavRow>
  );
};

export default FavItem;



// WEBPACK FOOTER //
// ./src/containers/Favorites/FavItem.tsx